import React, {Component} from 'react';
import PropTypes from 'prop-types';

const className = 'PaginationWidget__block';
class PaginationBlock extends Component {
	constructor(props) {
		super(props);

		this.setPageIndex = this.setPageIndex.bind(this);
	}

	setPageIndex(e) {
		e.preventDefault();
		this.props.setPageIndex(this.props.page, this.props.currentPageIndex);
	}

	render() {
		const activeClassName = this.props.currentPageIndex === this.props.page ? `${className}--active sdk-primary-cta` : 'sdk-primary-text';
		const componentClassName = `${className} ${activeClassName} ${this.props.className}`;
		return this.props.url ? this.renderLink(componentClassName) :  this.renderButton(componentClassName);
	}

	renderLink(componentClassName) {
		const attrs = {};

		if (this.props.page < this.props.currentPageIndex) {
			attrs.rel = 'prev';
		}

		if (this.props.page > this.props.currentPageIndex) {
			attrs.rel = 'next';
		}

		return (
			<a
				className={componentClassName}
				href={this.props.url}
				onMouseDown={this.setPageIndex}
				{...attrs}
			>
				{this.props.children || (this.props.page + 1)}
			</a>
		)
	}

	renderButton(componentClassName) {
		return (
			<button
				type="button"
				className={componentClassName}
				onClick={this.setPageIndex}
				aria-label={`Set page to ${this.props.page + 1}`}
			>
				{this.props.children || (this.props.page + 1)}
			</button>
		);
	}
}

PaginationBlock.defaultProps = {
	className: ''
};

PaginationBlock.propTypes = {
	page            : PropTypes.number,
	currentPageIndex: PropTypes.number,
	className       : PropTypes.string,
	setPageIndex    : PropTypes.func,
	url             : PropTypes.string,
};

export default PaginationBlock;


// WEBPACK FOOTER //
// ./src/frontend-standard-library/modules-react/Base/Component/PaginationWidget/PaginationBlock.js